import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSubject = new BehaviorSubject<any>(null);
  public user$ = this.userSubject.asObservable();

  constructor(private httpService: HttpService) {
    this.loadUserFromStorage();
  }

  private loadUserFromStorage(): void {
    const userJSON = localStorage.getItem('userDB');
    if (userJSON) {
      const userData = JSON.parse(userJSON);
      this.userSubject.next(userData?.user || userData);
    }
  }

  getCurrentUser(): any {
    return this.userSubject.value;
  }

  async updateUser(userId: string): Promise<void> {
    try {
      const cachedBefore = localStorage.getItem('userDB');
      const userData = await this.httpService.get(`user/${userId}`, this.httpService.getOpts()).toPromise();

      // A page saved a change to the cached user (e.g. a new default address)
      // while this GET was in flight. The response predates that change, so
      // writing it would silently undo it and later saves would send the stale
      // copy back to the server. Keep the newer local copy.
      if (localStorage.getItem('userDB') !== cachedBefore) {
        return;
      }

      // Update localStorage
      const storedData = JSON.parse(localStorage.getItem('userDB') || '{}');
      storedData.user = userData;
      localStorage.setItem('userDB', JSON.stringify(storedData));
      
      // Update the observable
      this.userSubject.next(userData);
    } catch (error) {
      console.error('Error updating user:', error);
    }
  }

  async updateUserType(userId: string, type: string): Promise<void> {
    try {
      // Update user type on server
      await this.httpService.put(`user/${userId}`, { type }, this.httpService.getOpts()).toPromise();
      
      // Refresh user data
      await this.updateUser(userId);
    } catch (error) {
      console.error('Error updating user type:', error);
    }
  }

  setUser(user: any): void {
    this.userSubject.next(user);
  }

  clearUser(): void {
    this.userSubject.next(null);
  }
}
